import { z } from 'zod'

import { validateAdUnitSizes } from 'features/globalSetup/features/viewport'
import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { zPercentage } from 'utils/zod'
import { AdUnitForForm } from '../GeneralForm/hooks/useGetAdUnit'
import { validateRefreshRedirectSchema } from './validator'

const basicSettingsSchema = z.object({
  customizeRefresherBasicSettingsEnabled: z.boolean().default(false),
  desktopAdThreshold: zPercentage.default(80),
  desktopMonitorUserScrollEnabled: z.boolean().default(false),
  desktopRefreshInterval: z.number().min(0).max(MAX_SAFE_GQL_INTEGER).default(30),
  mobileAdThreshold: zPercentage.default(80),
  mobileMonitorUserScrollEnabled: z.boolean().default(false),
  mobileRefreshInterval: z.number().min(0).max(MAX_SAFE_GQL_INTEGER).default(30),
})

const refreshRedirectSchema = z.object({
  additionalSizes: z.string().array().superRefine(validateAdUnitSizes),
  sendRefreshRequestToExternalAdUnitEnabled: z.boolean().default(false),
  targetAdUnitPath: z.string().optional(),
})
export type RefreshRedirectSchema = z.infer<typeof refreshRedirectSchema>

export const schema = z
  .object({
    basicSettings: basicSettingsSchema,
    id: z.string(),
    refresherEnabled: z.boolean(),
    refreshRedirect: refreshRedirectSchema,
  })
  .superRefine(({ refreshRedirect }, ctx): void => {
    validateRefreshRedirectSchema(refreshRedirect, ctx)
  })

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({ adUnitRefresher, id, refresherEnabled }: AdUnitForForm): Schema => {
  return {
    basicSettings: {
      customizeRefresherBasicSettingsEnabled:
        adUnitRefresher.customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold: adUnitRefresher.desktopAdThreshold,
      desktopMonitorUserScrollEnabled: adUnitRefresher.desktopMonitorUserScrollEnabled,
      desktopRefreshInterval: adUnitRefresher.desktopRefreshInterval,
      mobileAdThreshold: adUnitRefresher.mobileAdThreshold,
      mobileMonitorUserScrollEnabled: adUnitRefresher.mobileMonitorUserScrollEnabled,
      mobileRefreshInterval: adUnitRefresher.mobileRefreshInterval,
    },
    id,
    refresherEnabled,
    refreshRedirect: {
      additionalSizes: adUnitRefresher.additionalSizes,
      sendRefreshRequestToExternalAdUnitEnabled:
        adUnitRefresher?.sendRefreshRequestToExternalAdUnitEnabled ?? false,
      targetAdUnitPath: adUnitRefresher?.targetAdUnitPath,
    },
  }
}
